import * as React from "react";
import { mergeClassNames } from "./class-names";
import { Heading, Text } from "./typography";

export interface PageHeaderProps {
  readonly title: React.ReactNode;
  readonly headingLevel?: 1 | 2;
  readonly description?: React.ReactNode;
  readonly eyebrow?: React.ReactNode;
  readonly actions?: React.ReactNode;
  readonly className?: string;
}

export function PageHeader({
  title,
  headingLevel = 1,
  description,
  eyebrow,
  actions,
  className,
}: PageHeaderProps) {
  return (
    <header
      data-slot="page-header"
      className={mergeClassNames(
        "border-b border-border-subtle bg-surface",
        className,
      )}
    >
      <div className="mx-auto flex w-full max-w-app flex-col gap-4 px-4 py-6 sm:px-6 lg:flex-row lg:items-end lg:justify-between lg:px-8">
        <div className="min-w-0 max-w-reading">
          {eyebrow === undefined ? null : (
            <Text
              as="p"
              size="small"
              className="font-semibold uppercase tracking-wide text-brand-ink"
            >
              {eyebrow}
            </Text>
          )}
          <Heading
            level={headingLevel}
            size="xxlarge"
            className={eyebrow === undefined ? undefined : "mt-1"}
          >
            {title}
          </Heading>
          {description === undefined ? null : (
            <Text size="large" className="mt-2 text-secondary">
              {description}
            </Text>
          )}
        </div>
        {actions === undefined ? null : (
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            {actions}
          </div>
        )}
      </div>
    </header>
  );
}
